import { render, staticRenderFns } from "./SideRBar.vue?vue&type=template&id=fb6ba120"
import script from "./SideRBar.vue?vue&type=script&lang=js"
export * from "./SideRBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports